import React, { Component } from "react"
import axios from "axios"
import { withTranslation } from "react-i18next"
import { createNewFolder, fetchFolders } from "apps/simplified-web/src/_actions/folderActions"
import { connect } from "react-redux"
import { Box, Button, Flex, Icon, SimpleGrid, Text } from "@chakra-ui/react"
import { FaArrowLeft, FaPlus } from "react-icons/fa"
import { ShowCenterSpinner } from "../../../common/statelessView"
import FolderCard from "../../../home/FolderCard"
import FolderContentsView from "./SliderPanelFolderContentsView"
import PropTypes from "prop-types"
import { TldrNewFolderDialog } from "../../../styled/home/statelessView"
import { openSlider } from "apps/simplified-web/src/_actions/sidebarSliderActions"

const subtitleStyles = {
  color: "brand.white",
  fontSize: "1.125rem",
  fontWeight: "500",
  fontSize: "1rem",
  marginBottom: "3",
  alignItems: "center",
}

class FoldersSliderPanel extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props)

    this.state = {
      selectedFolder: null,
      showNewFolderModal: false,
      inProgress: false,
    }
  }

  handleOnFolderClick = (folder) => {
    this.setState({
      selectedFolder: folder,
    })
  }

  handleOnBackClick = () => {
    this.setState({
      selectedFolder: null,
    })
  }

  openPreviousPanel = () => {
    this.props.openSlider(this.props.previousSliderPanel);
  }

  openNewFolderModal = () => {
    this.setState({
      showNewFolderModal: true,
    })
  }

  hideNewFolderModal = () => {
    this.setState({
      showNewFolderModal: false,
    })
  }

  render() {
    const {
      t,
      canvasRef,
      folders,
      loaded,
      onTemplateClick,
      onAssetClick,
      onProjectClick,
      isDragAndDropContextAvailable,
      storyCardTab,
    } = this.props
    const { selectedFolder, showNewFolderModal, inProgress } = this.state

    return (
      <>
        <Box pr={4}>
          <Flex direction="row" align="center" justify="space-between">
            {selectedFolder ? (
              <>
                <Text
                  sx={subtitleStyles}
                  onClick={this.handleOnBackClick}
                  _hover={{
                    cursor: "pointer",
                  }}
                >
                  <Icon as={FaArrowLeft} mr={2} />
                  {selectedFolder.name}
                </Text>
              </>
            ) : null}
          </Flex>
        </Box>

        {!selectedFolder ? (
          <Box pr={4} flex="1">
            {!loaded ? (
              <ShowCenterSpinner loaded={loaded}></ShowCenterSpinner>
            ) : loaded && folders.length === 0 ? (
                <Flex
                  h="100%"
                  align="center"
                  justify="center"
                  direction="column"
                >
                  <Text
                    textAlign="center"
                    color="gray.200"
                  >
                    {t("empty_screen.description", { ns: "folders" })}
                  </Text>
                  <Button
                    leftIcon={<FaPlus />}
                    mt={2}
                    onClick={this.openNewFolderModal}
                  >
                    {t("new_folder_button.text", { ns: "folders" })}
                  </Button>
                </Flex>
              ) : loaded && folders.length > 0 ? (
                <SimpleGrid columns={2} spacing={2}>
                  {folders.map((folder) => (
                    <FolderCard
                      key={folder.id}
                      folder={folder}
                      onClick={() => this.handleOnFolderClick(folder)}
                      maxWidth={"90px"}
                    />
                  ))}
                </SimpleGrid>
            ) : null}
          </Box>
        ) : (
            <FolderContentsView
              folder={selectedFolder}
              onTemplateClick={onTemplateClick}
              onAssetClick={onAssetClick}
              onProjectClick={onProjectClick}
              isDragAndDropContextAvailable={isDragAndDropContextAvailable}
              storyCardTab={storyCardTab}
            />
        )}

        {showNewFolderModal ? (
          <TldrNewFolderDialog
            inProgress={inProgress}
            show={showNewFolderModal}
            onHide={this.hideNewFolderModal}
            onYes={(name) => {
              this.setState({ inProgress: true }, () => this.createFolder(name))
            }}
          />
        ) : null}
      </>
    )
  }

  componentDidMount() {
    this.fetchMyFolders()
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.")
  }

  fetchMyFolders = () => {
    const payload = {
      searchTerm: "",
      props: this.props,
      updateRecent: false,
    }

    this.props.fetchFolders(payload, this.signal.token)
  }

  createFolder = (name) => {
    this.props.createNewFolder(name, this.signal.token, this.props)
      .then(() => {
        this.setState({
          inProgress: false,
          showNewFolderModal: false,
        })
        this.fetchMyFolders()
      })
      .catch(() => {
        this.setState({
          inProgress: false,
          showNewFolderModal: false,
        })
      })
  }
}

FoldersSliderPanel.propTypes = {
  onTemplateClick: PropTypes.func.isRequired,
  onAssetClick: PropTypes.func.isRequired,
  onProjectClick: PropTypes.func.isRequired,
  storyCardTab: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => ({
  folders: state.folders.folders,
  loaded: state.folders.loaded,
  foldersPage: state.folders.foldersPage,
  previousSliderPanel: state.sidebarSlider.previousSliderPanelType,
})

const mapDispatchToProps = (dispatch) => ({
  fetchFolders: (payload, signal) => dispatch(fetchFolders(payload, signal)),
  createNewFolder: (name, signal, props) =>
    dispatch(createNewFolder(name, signal, props)),
  openSlider: (panel) => dispatch(openSlider(panel)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(["common", "folders"])(FoldersSliderPanel))